import { Component, Vue } from 'vue-property-decorator'

@Component({
  metaInfo(): Object {
    return {
      title: this.$options.filters?.capitalize(this.$t('titles.' + this.$route.name?.toLowerCase())) + ' - '
    }
  }
})
class viewMetaMixin extends Vue {}

export default viewMetaMixin
